import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const escapeTelegramHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}[character]));

function ComparisonDetailsPage() {

  const { id } = useParams();
  const navigate = useNavigate();

  // 🔐 User Authentication Role (Change to "Purchase" to test locking out edit privileges)
const [currentUser] = useState(
  JSON.parse(localStorage.getItem("user")) || {}
);

const isAdmin = currentUser.role?.toLowerCase() === "admin";
const isSuperAdmin = ["super_admin", "super admin"].includes(currentUser.role?.toLowerCase());
const isManager = currentUser.role?.toLowerCase() === "manager";
const isPurchase = ["purchase", "accounts"].includes(currentUser.role?.toLowerCase());
const canSendPO = isAdmin || isSuperAdmin || isPurchase;

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    items: [],
    vendors: [],
    quotations: [],
    status: ""
  });
const [newItem, setNewItem] = useState({
  item_name: "",
  quantity: "",
  uom: "",
  rates: {}
});
  // 📝 Track temporary admin input overrides before submitting to the backend
  // Key format: "itemId-vendorId"
  const [adminOverrides, setAdminOverrides] = useState({});
  const [addingRow, setAddingRow] = useState(false);
  const [adminGstOverrides, setAdminGstOverrides] = useState({});
  const [isEditingRates, setIsEditingRates] = useState(false);
  const [isSavingRates, setIsSavingRates] = useState(false);
  const [activeEditCell, setActiveEditCell] = useState(null);
  const [showAttachments, setShowAttachments] = useState(false);
  const [showBreakdown, setShowBreakdown] = useState(true);
  const [showTelegramModal, setShowTelegramModal] = useState(false);
  const [telegramMessage, setTelegramMessage] = useState("Please review and approve this RFQ.");
  const [isSendingTelegram, setIsSendingTelegram] = useState(false);

  const fetchComparison = React.useCallback(async () => {
    try {
     const token = localStorage.getItem("token");

const res = await fetch(
  `${process.env.REACT_APP_API_URL}/comparison/${id}`,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);
      const result = await res.json();

      const rfqRes = await fetch(
  `${process.env.REACT_APP_API_URL}/rfq-list`,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);
      const rfqs = await rfqRes.json();

      const currentRfq = rfqs.find(
        (r) => Number(r.id) === Number(id)
      );

      setData({
        ...result,
        status: currentRfq?.status || "Pending"
      });

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchComparison();
  }, [id]);

  // Enhanced to look for local admin overrides first, then fall back to DB data
  const getQuoteRate = (itemId, vendorId) => {
    const overrideKey = `${itemId}-${vendorId}`;
    if (adminOverrides[overrideKey] !== undefined) {
      return adminOverrides[overrideKey] === "" ? 0 : Number(adminOverrides[overrideKey]);
    }

    const quote = data.quotations.find(
      (q) =>
        Number(q.item_id) === Number(itemId) &&
        Number(q.vendor_id) === Number(vendorId)
    );
    return quote ? Number(quote.rate) : 0;
  };

  const getQuotation = (itemId, vendorId) => data.quotations.find(
    (q) => Number(q.item_id) === Number(itemId) && Number(q.vendor_id) === Number(vendorId)
  );

  const getGstPercent = (gstType) => {
    const percentMatch = String(gstType || "").match(/\d+(?:\.\d+)?/);
    const parsedPercent = percentMatch ? Number(percentMatch[0]) : 0;
    return Number.isFinite(parsedPercent) ? parsedPercent : 0;
  };

  const getLineAmounts = (item, vendorId) => {
    const rate = getQuoteRate(item.item_id, vendorId);
    const baseAmount = rate * Number(item.quantity || 0);
    const overrideKey = `${item.item_id}-${vendorId}`;
    const gstPercent = adminGstOverrides[overrideKey] !== undefined
      ? Number(adminGstOverrides[overrideKey])
      : getGstPercent(getQuotation(item.item_id, vendorId)?.gst_type);
    const gstAmount = baseAmount * gstPercent / 100;

    return { rate, gstPercent, baseAmount, gstAmount, totalAmount: baseAmount + gstAmount };
  };

  const handleAdminRateChange = (itemId, vendorId, value) => {
    if (value !== "" && (!/^\d*\.?\d{0,2}$/.test(value) || Number(value) < 0)) return;

    const overrideKey = `${itemId}-${vendorId}`;
    setAdminOverrides((prev) => ({
      ...prev,
      [overrideKey]: value
    }));
  };
  const handleAddItem = async () => {

    try {

        const res = await fetch(
    `${process.env.REACT_APP_API_URL}/api/comparison/${id}/add-item`,
    {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({
            item_name: newItem.item_name,
            quantity: Number(newItem.quantity),
            uom: newItem.uom,
            vendors: Object.entries(newItem.rates).map(([vendor_id, rate]) => ({
                vendor_id: Number(vendor_id),
                rate: Number(rate),
                gst_type: "Without GST"
            }))
        })
    }
);

        const result = await res.json();

        console.log(result);

        if (result.success) {

            alert("Item Added Successfully ✅");

            setAddingRow(false);

setNewItem({
    item_name: "",
    quantity: "",
    uom: "",
    rates: {}
});

            fetchComparison();

        } else {

            alert(result.error);

        }

    } catch (err) {

        console.log(err);

        alert("Server Error");

    }

};

  const handleAdminGstChange = (itemId, vendorId, value) => {
    if (value !== "" && (!/^\d*\.?\d{0,2}$/.test(value) || Number(value) < 0 || Number(value) > 100)) return;

    const overrideKey = `${itemId}-${vendorId}`;
    setAdminGstOverrides((prev) => ({ ...prev, [overrideKey]: value }));
  };

  const getVendorSummary = (vendorId) => data.items.reduce(
    (summary, item) => {
      const line = getLineAmounts(item, vendorId);
      return {
        baseAmount: summary.baseAmount + line.baseAmount,
        gstAmount: summary.gstAmount + line.gstAmount,
        totalAmount: summary.totalAmount + line.totalAmount
      };
    },
    { baseAmount: 0, gstAmount: 0, totalAmount: 0 }
  );

  const getVendorTotal = (vendorId) => getVendorSummary(vendorId).totalAmount;

  // SORT VENDORS => L1 L2 L3 (Includes updated live totals)
  const vendorColumnCount = 3 + (showBreakdown ? 2 : 0) + (showAttachments ? 1 : 0);

  const rankedVendors = [...data.vendors]
    .map((vendor) => ({
      ...vendor,
      total: getVendorTotal(vendor.vendor_id)
    }))
    .sort((a, b) => a.total - b.total);

  const getVendorRank = (vendorId) => {
    const index = rankedVendors.findIndex(
      (v) => v.vendor_id === vendorId
    );
    return `L${index + 1}`;
  };

  const getRankColors = (rank) => {
    if (rank === "L1") return { fg: "#15803d", bg: "#f0fdf4", border: "#bbf7d0" };
    if (rank === "L2") return { fg: "#b45309", bg: "#fffbeb", border: "#fde68a" };
    if (rank === "L3") return { fg: "#b91c1c", bg: "#fef2f2", border: "#fecaca" };
    return { fg: "#475569", bg: "#f8fafc", border: "#e2e8f0" };
  };

  // Kept for any external usage relying on a single hex value
  const getRankColor = (rank) => getRankColors(rank).fg;

  const getStatusColors = (status) => {
    const s = (status || "").toLowerCase();
    if (s === "approved") return { fg: "#15803d", bg: "#f0fdf4", border: "#bbf7d0" };
    if (s === "rejected") return { fg: "#b91c1c", bg: "#fef2f2", border: "#fecaca" };
    return { fg: "#b45309", bg: "#fffbeb", border: "#fde68a" }; // Pending / default
  };

  // Push overwritten rates to database endpoint
  const handleSaveAdminRates = async () => {
  const updates = [...new Set([...Object.keys(adminOverrides), ...Object.keys(adminGstOverrides)])]
    .filter((key) => adminOverrides[key] !== "")
    .map((key) => {
      const [itemId, vendorId] = key.split("-");
      return {
        item_id: Number(itemId),
        vendor_id: Number(vendorId),
        rate: getQuoteRate(itemId, vendorId),
        gst_type: getLineAmounts({ item_id: itemId, quantity: 0 }, vendorId).gstPercent
          ? `${getLineAmounts({ item_id: itemId, quantity: 0 }, vendorId).gstPercent}%`
          : "Without GST"
      };
    });

  if (updates.length === 0) {
    setIsEditingRates(false);
    return;
  }

  try {
    setIsSavingRates(true);
    // 🔗 Ensure /api/ is present if your base environment URL doesn't include it
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/comparison/${id}/update-rates`, {
      method: "POST",
      headers: {
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`
},
      body: JSON.stringify({ rates: updates })
    });
    
    const result = await res.json();
    if (result.success || res.ok) {
      alert("Pricing updated successfully by Admin! ✅");
      setAdminOverrides({});
      setAdminGstOverrides({});
      setIsEditingRates(false);
      setActiveEditCell(null);
      fetchComparison(); // Reload values cleanly from DB
    } else {
      alert("Failed to update custom admin rates. ❌");
    }
  } catch (err) {
    console.error(err);
    alert("Network exception writing overrides data payload ❌");
  } finally {
    setIsSavingRates(false);
  }
};

  const handleCancelRateEdit = () => {
    setAdminOverrides({});
    setAdminGstOverrides({});
    setIsEditingRates(false);
    setActiveEditCell(null);
  };

  const handleApprove = async () => {
    if (!selectedVendor) {
      alert("Please select vendor");
      return;
    }

    const vendorData = rankedVendors.find(
      (v) => v.vendor_id === selectedVendor
    );

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/approve-rfq`,
        {
          method: "POST",
          headers: {
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`
},
          body: JSON.stringify({
            rfq_id: id,
            approved_vendor_id: selectedVendor,
            approved_amount: vendorData.total,
            remarks: "Approved by Admin Override Layer"
          })
        }
      );

      const result = await res.json();
      if (result.success) {
        alert("RFQ Approved Successfully");
        fetchComparison();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSendPO = async () => {
    if (!selectedVendor) {
      alert("Please select vendor");
      return;
    }

  const selectedVendorData = data.vendors.find(
    (v) => Number(v.vendor_id) === Number(selectedVendor)
  );

  const formattedItems = data.items.map((item) => {
    const rate = getQuoteRate(item.item_id, selectedVendor);

    return {
      name: (item.item_name || "").trim(),
      qty: item.quantity || 0,
      price: rate
    };
  });
  console.log("Vendor Data:", selectedVendorData);

  navigate("/purchase-order", {
    state: {
      vendor_id: selectedVendor,
      comparison_id: id,
      approval_status: data.status || "Pending",

      vendor_name: selectedVendorData?.vendor_name || "",

      vendor_gst: selectedVendorData?.gst_no || "",
      vendor_contact: selectedVendorData?.contact_person || "",
      vendor_phone: selectedVendorData?.contact_number || "",

      vendor_address_line1:
        selectedVendorData?.address_line1 || "",

      vendor_address_line2:
        selectedVendorData?.address_line2 || "",

      vendor_address_line3:
        selectedVendorData?.address_line3 || "",

      site_id: data.site_id || "",
      site_name: data.site_name || "",

      items: formattedItems
    }
  });
  };

  const handleSendTelegramApproval = async () => {
    if (!telegramMessage.trim()) {
      alert("Please enter a message");
      return;
    }
    setIsSendingTelegram(true);
    const rfqDate = data.created_at ? new Date(data.created_at).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB");
    const completeMessage = `<b>🏢 ENSILETA INTERIORS</b>\n━━━━━━━━━━━━━━━━━━\n<b>🔔 APPROVAL REQUIRED</b>\n\n📍 <b>Site:</b> ${escapeTelegramHtml(data.site_name || "—")}\n📋 <b>RFQ No:</b> #${escapeTelegramHtml(id)}\n📅 <b>Date:</b> ${rfqDate}\n\n💬 <b>Message:</b>\n${escapeTelegramHtml(telegramMessage.trim())}\n\n━━━━━━━━━━━━━━━━━━\nPlease review the RFQ Comparison and take the required action.\nThank you.`;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/comparison/${id}/telegram-approval`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: JSON.stringify({ message: completeMessage })
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || "Unable to send Telegram notification");
      setShowTelegramModal(false);
      alert("Approval notification sent to Telegram successfully");
    } catch (err) {
      alert(err.message);
    } finally {
      setIsSendingTelegram(false);
    }
  };

  const statusColors = getStatusColors(data.status);

  return (
    <>
    <div style={pageWrap}>
      <div style={card}>

        {/* PAGE HEADER */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "16px" }}>
          <div>
            <div style={eyebrow}>PROCUREMENT</div>
            <h1 style={pageTitle}>RFQ Comparison Sheet</h1>
            <p style={pageSubtitle}>Compare vendor quotations, resolve pricing, and authorize a purchase order.</p>
          </div>

          <span
            style={{
              ...statusPill,
              color: statusColors.fg,
              background: statusColors.bg,
              borderColor: statusColors.border
            }}
          >
            <span style={{ ...statusDot, background: statusColors.fg }} />
            {data.status || "Pending"}
          </span>
        </div>

        {/* META INFO BAR */}
        <div style={metaBar}>
          <div style={metaItem}>
            <span style={metaLabel}>RFQ No.</span>
            <span style={metaValue}>#{id}</span>
          </div>
          <div style={metaDivider} />
          <div style={metaItem}>
            <span style={metaLabel}>Site</span>
            <span style={metaValue}>{data.site_name || "—"}</span>
          </div>
          <div style={metaDivider} />
          <div style={metaItem}>
            <span style={metaLabel}>Vendors quoted</span>
            <span style={metaValue}>{data.vendors.length}</span>
          </div>
          <div style={metaDivider} />
          <div style={metaItem}>
            <span style={metaLabel}>Line items</span>
            <span style={metaValue}>{data.items.length}</span>
          </div>
        </div>

        {isAdmin && (
          <div style={adminNotice}>
            <div>
              <div style={adminNoticeTitle}>Admin price control</div>
              <div style={adminNoticeText}>
                {isEditingRates
                  ? "Update rate and GST % below. GST amount, total, ranking, and approval value update instantly."
                  : "Review vendor prices, GST, and totals. Enter manual values for any line item when needed."}
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>

  {!isEditingRates && (
    <button
      onClick={() => {
        setShowBreakdown(true);
        setIsEditingRates(true);
      }}
      style={editRatesBtn}
    >
      Edit Pricing
    </button>
  )}

  <button
    onClick={() => setAddingRow(true)}
    style={editRatesBtn}
  >
    + Add Item
  </button>

</div>
          </div>
        )}

        <div style={tableControls}>
          <span style={tableControlsLabel}>Table view</span>
          <label style={toggleLabel}>
            <input
              type="checkbox"
              checked={showBreakdown}
              onChange={(e) => setShowBreakdown(e.target.checked)}
            />
            Show GST % and base amount
          </label>
          <label style={toggleLabel}>
            <input
              type="checkbox"
              checked={showAttachments}
              onChange={(e) => setShowAttachments(e.target.checked)}
            />
            Show attachments
          </label>
        </div>

        {/* TABLE */}
        <div style={tableWrap}>
          {loading ? (
            <div style={emptyState}>Loading comparison data…</div>
          ) : data.items.length === 0 ? (
            <div style={emptyState}>No line items found for this RFQ.</div>
          ) : (
          <table style={{ width: "100%", minWidth: "max-content", borderCollapse: "collapse" }}>
            <thead>

              {/* First Header Row */}
              <tr style={theadRowPrimary}>
                <th
  rowSpan="2"
  style={{
    ...thStyle,
    position: "sticky",
    left: 0,
    zIndex: 30,
    background: "#f8fafc"
  }}
>
  Select
</th>
                <th
  rowSpan="2"
  style={{
    ...thStyle,
    position: "sticky",
    left: 60,
    zIndex: 30,
    background: "#f8fafc"
  }}
>
  Sl.No
</th>
                <th
  rowSpan="2"
  style={{
    ...thStyleLeft,
    position: "sticky",
    left: 120,
    zIndex: 30,
    background: "#f8fafc"
  }}
>
  Description
</th>
                <th
  rowSpan="2"
  style={{
    ...thStyle,
    position: "sticky",
    left: 470,
    zIndex: 30,
    background: "#f8fafc"
  }}
>
  Qty
</th>

                {data.vendors.map((vendor) => (
                  <th
                    key={vendor.vendor_id}
                    colSpan={vendorColumnCount}
                    style={{
                      ...thStyle,
                      textAlign: "center",
                      fontWeight: "700",
                      fontSize: "12.5px",
                      borderLeft: "1px solid rgba(255,255,255,0.14)"
                    }}
                  >
                    {vendor.vendor_name}
                  </th>
                ))}
              </tr>

              {/* Second Header Row */}
              <tr style={theadRowSecondary}>
                {data.vendors.map((vendor) => (
                  <React.Fragment key={vendor.vendor_id}>
                    <th style={{ ...thStyle, borderLeft: "1px solid rgba(255,255,255,0.14)" }}>Rate</th>
                    <th style={thStyle}>GST amount</th>
                    {showBreakdown && <th style={thStyle}>GST %</th>}
                    {showBreakdown && <th style={thStyle}>Base amount</th>}
                    <th style={thStyle}>Total amount</th>
                    {showAttachments && <th style={thStyle}>Attachment</th>}
                  </React.Fragment>
                ))}
              </tr>

            </thead>
            <tbody>
              {data.items.map((item, index) => (
                <tr key={item.item_id} style={bodyRow}>
                  {index === 0 && (
                    <td rowSpan={data.items.length} style={{
  ...tdStyle,
  position: "sticky",
  left: 0,
  zIndex: 20,
  background: "#fafbfc",
  verticalAlign: "top",
  paddingTop: "22px",
  textAlign: "center"
}}>
                      {rankedVendors.map((vendor) => {
                        const rank = getVendorRank(vendor.vendor_id);
                        const rc = getRankColors(rank);
                        const isChosen = selectedVendor === vendor.vendor_id;
                        return (
                          <div key={vendor.vendor_id} style={{ marginBottom: "16px" }}>
                            <label
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: canSendPO ? "pointer" : "default",
                                opacity: canSendPO ? 1 : 0.6
                              }}
                            >
                              <input
                                type="radio"
                                name="vendor"
                                checked={isChosen}
                                disabled={!canSendPO}
                                onChange={() => setSelectedVendor(vendor.vendor_id)}
                                style={{ accentColor: "#4338ca", width: "15px", height: "15px", cursor: canSendPO ? "pointer" : "not-allowed" }}
                              />
                            </label>
                            <div style={{ marginTop: "6px" }}>
                              <span
                                style={{
                                  color: rc.fg,
                                  background: rc.bg,
                                  border: `1px solid ${rc.border}`,
                                  padding: "3px 11px",
                                  borderRadius: "20px",
                                  fontSize: "11px",
                                  fontWeight: "700",
                                  letterSpacing: "0.02em"
                                }}
                              >
                                {rank}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </td>
                  )}

                  <td
  style={{
    ...tdStyle,
    position: "sticky",
    left: 60,
    zIndex: 20,
    background: "#fff",
    color: "#64748b"
  }}
>{index + 1}</td>
                  <td
  style={{
    ...tdStyleLeft,
    position: "sticky",
    left: 120,
    zIndex: 20,
    background: "#fff",
    fontWeight: "600",
    color: "#0f172a"
  }}
>{item.item_name}</td>
                  <td
  style={{
    ...tdStyle,
    position: "sticky",
    left: 470,
    zIndex: 20,
    background: "#fff"
  }}
>
      <span style={{ fontWeight: "600" }}>{item.quantity}</span>{" "}
      <span style={{ color: "#94a3b8", fontSize: "12px" }}>{item.uom}</span>
  </td>

                  {data.vendors.map((vendor) => {
                    // Pull explicit historical quotation value from db context loop
                    const rawQuote = getQuotation(item.item_id, vendor.vendor_id);
                    const attachment = rawQuote?.attachment;
                    
                    const { rate, gstPercent, baseAmount, gstAmount, totalAmount } = getLineAmounts(item, vendor.vendor_id);
                    const rank = getVendorRank(vendor.vendor_id);
                    const isBest = rank === "L1";

                    return (
                      <React.Fragment key={vendor.vendor_id}>
                        <td style={{ ...tdStyleRight, borderLeft: "1px solid #e5e7eb", background: isBest ? "#f0fdf4" : "#fff", fontWeight: isBest ? "700" : "500", color: isBest ? "#15803d" : "#0f172a" }}>
                          {isAdmin && isEditingRates ? (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "3px" }}>
                              <span style={{ color: "#4f46e5", fontWeight: "700", fontSize: "12px" }}>₹</span>
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                placeholder="0"
                                value={adminOverrides[`${item.item_id}-${vendor.vendor_id}`] ?? String(rate)}
                                onChange={(e) => handleAdminRateChange(item.item_id, vendor.vendor_id, e.target.value)}
                                style={adminInputStyle}
                                aria-label={`Rate for ${item.item_name} from ${vendor.vendor_name}`}
                              />
                            </div>
                          ) : (
                            `₹ ${rate}`
                          )}
                        </td>
                        <td style={{ ...tdStyleRight, background: isBest ? "#f0fdf4" : "#fff" }}>
                          ₹ {gstAmount.toLocaleString()}
                        </td>
                        {showBreakdown && (
                          <td style={{ ...tdStyle, textAlign: "center", background: isBest ? "#f0fdf4" : "#fff" }}>
                            {isAdmin && isEditingRates ? (
                              <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                value={adminGstOverrides[`${item.item_id}-${vendor.vendor_id}`] ?? String(gstPercent)}
                                onChange={(e) => handleAdminGstChange(item.item_id, vendor.vendor_id, e.target.value)}
                                style={gstInputStyle}
                                aria-label={`GST percentage for ${item.item_name} from ${vendor.vendor_name}`}
                              />
                            ) : (
                              gstPercent ? `${gstPercent}%` : "—"
                            )}
                          </td>
                        )}
                        {showBreakdown && (
                          <td style={{ ...tdStyleRight, background: isBest ? "#f0fdf4" : "#fff" }}>
                            ₹ {baseAmount.toLocaleString()}
                          </td>
                        )}
                        <td style={{ ...tdStyleRight, background: isBest ? "#dcfce7" : "#fff", fontWeight: "700", color: isBest ? "#15803d" : "#0f172a" }}>
                          ₹ {totalAmount.toLocaleString()}
                        </td>
{showAttachments && <td style={{ ...tdStyle, background: isBest ? "#f0fdf4" : "#fff" }}>

  {attachment ? (

    attachment.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (

      <img
        src={attachment}
        alt="Attachment"
        style={thumbStyle}
        onClick={() => window.open(attachment, "_blank")}
      />

    ) : (

      <a
       href={attachment}
        target="_blank"
        rel="noreferrer"
        style={fileLinkStyle}
      >
        📄 View
      </a>

    )

  ) : (

    <span style={{ color: "#cbd5e1", fontSize: "12px" }}>
      No attachment
    </span>

  )}

</td>}

                      </React.Fragment>
                    );
                  })}
                </tr>
              ))}

              {addingRow && (
<tr style={{background:"#fff8dc"}}>

<td></td>

<td>{data.items.length+1}</td>

<td>
<input
    value={newItem.item_name}
    onChange={(e) =>
        setNewItem({
            ...newItem,
            item_name: e.target.value
        })
    }
    style={{width:"100%"}}
/>
</td>

<td>
<input
    value={newItem.quantity}
    onChange={(e)=>
        setNewItem({
            ...newItem,
            quantity:e.target.value
        })
    }
    style={{width:"60px"}}
/>
</td>

{data.vendors.map(v=>(
<React.Fragment key={v.vendor_id}>

<td>
<input
    value={newItem.rates[v.vendor_id] || ""}
    onChange={(e)=>
        setNewItem({
            ...newItem,
            rates:{
                ...newItem.rates,
                [v.vendor_id]:e.target.value
            }
        })
    }
    style={{width:"80px"}}
/>
</td>

<td></td>                       {/* GST Amount */}

{showBreakdown && <td></td>}    {/* GST % */}

{showBreakdown && <td></td>}    {/* Base */}

<td>
    <button
        onClick={handleAddItem}
        style={saveAdminBtn}
    >
        Save
    </button>
</td>

{showAttachments && <td></td>}

</React.Fragment>
))}

</tr>
)}

              {/* GRAND TOTAL */}
              <tr style={{ background: "#f8fafc" }}>
                <td colSpan="4" style={{ ...tdStyle, fontSize: "14px", fontWeight: "700", color: "#0f172a", letterSpacing: "0.01em" }}>
                  GRAND TOTAL
                </td>
                {data.vendors.map((vendor) => {
                  const vendorSummary = getVendorSummary(vendor.vendor_id);
                  const total = vendorSummary.totalAmount;
                  const rank = getVendorRank(vendor.vendor_id);
                  const rc = getRankColors(rank);
                  const isBest = rank === "L1";

                  return (
                    <React.Fragment key={vendor.vendor_id}>
  {/* Vendor Rank */}
  <td style={{ ...tdStyle, textAlign: "center", borderLeft: "1px solid #e5e7eb" }}>
    <span
      style={{
        color: rc.fg,
        background: rc.bg,
        border: `1px solid ${rc.border}`,
        padding: "4px 12px",
        borderRadius: "20px",
        fontSize: "11px",
        fontWeight: "700"
      }}
    >
      {rank}
    </span>
  </td>

  <td style={tdStyleRight}>₹ {vendorSummary.gstAmount.toLocaleString()}</td>
  {showBreakdown && <td style={{ ...tdStyle, textAlign: "center" }}>—</td>}
  {showBreakdown && <td style={tdStyleRight}>₹ {vendorSummary.baseAmount.toLocaleString()}</td>}

  {/* Grand Total */}
  <td
    style={{
      ...tdStyleRight,
      background: isBest ? "#dcfce7" : "#fff",
      fontWeight: "700",
      fontSize: "15px",
      color: isBest ? "#15803d" : "#0f172a"
    }}
  >
    ₹ {total.toLocaleString()}
  </td>
  {showAttachments && <td style={{ ...tdStyle, textAlign: "center" }}>—</td>}
</React.Fragment>
                  );
                })}
              </tr>
            </tbody>
          </table>
          )}
        </div>

        {/* CONTROLS ACTION FOOTER BAR */}
        <div style={footerBar}>
          
          {/* Admin Exclusive Save Changes Controller */}
          {isAdmin && isEditingRates && (
            <>
              <button onClick={handleCancelRateEdit} disabled={isSavingRates} style={cancelBtn}>
                Cancel
              </button>
              <button
                onClick={handleSaveAdminRates}
                disabled={isSavingRates}
                style={{ ...saveAdminBtn, opacity: isSavingRates ? 0.65 : 1 }}
              >
                {isSavingRates ? "Saving…" : "Save pricing changes"}
              </button>
            </>
          )}

          {/* Admin can approve only */}
{(isAdmin || isSuperAdmin || isManager) && data.status !== "Approved" && (
  <button onClick={handleApprove} style={approveBtn}>
    Authorize vendor
  </button>
)}

{/* Admin or Purchase can send PO after approval */}
{canSendPO && (
  <button
    onClick={handleSendPO}
    disabled={data.status !== "Approved"}
    style={{
      ...poBtn,
      opacity: data.status === "Approved" ? 1 : 0.5,
      cursor: data.status === "Approved" ? "pointer" : "not-allowed"
    }}
  >
    Send PO
  </button>
)}
          <button
            onClick={() => setShowTelegramModal(true)}
            style={{ ...notificationBtn, opacity: isSendingTelegram ? 0.6 : 1 }}
            disabled={isSendingTelegram}
          >
            Send Approval Notification
          </button>
        </div>
      </div>
    </div>
    {showTelegramModal && (
      <div style={telegramOverlay} role="dialog" aria-modal="true" aria-labelledby="telegram-title">
        <div style={telegramModal}>
          <div style={telegramHeader}>
            <div>
              <div id="telegram-title" style={telegramTitle}>Send Approval Notification</div>
              <div style={telegramSubtitle}>Telegram message preview</div>
            </div>
            <button type="button" onClick={() => setShowTelegramModal(false)} style={telegramCloseBtn}>×</button>
          </div>
          <div style={telegramDetails}>
            <div><b>Site:</b> {data.site_name || "—"}</div>
            <div><b>RFQ:</b> #{id}</div>
            <div><b>Date:</b> {data.created_at ? new Date(data.created_at).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB")}</div>
          </div>
          <div style={telegramRecipientNote}>Recipients are managed securely in the backend Railway environment settings.</div>
          <label style={telegramLabel}>
            Custom message
            <textarea value={telegramMessage} onChange={(e) => setTelegramMessage(e.target.value)} rows={5} style={telegramTextarea} placeholder="Please review and approve this RFQ." />
          </label>
          <div style={telegramPreview}><b>Message preview</b><pre style={telegramPre}>{`🏢 ENSILETA INTERIORS\n━━━━━━━━━━━━━━━━━━\n🔔 APPROVAL REQUIRED\n\n📍 Site: ${data.site_name || "—"}\n📋 RFQ No: #${id}\n📅 Date: ${data.created_at ? new Date(data.created_at).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB")}\n\n💬 Message:\n${telegramMessage || "—"}\n\n━━━━━━━━━━━━━━━━━━\nPlease review the RFQ Comparison and take the required action.\nThank you.`}</pre></div>
          <div style={telegramActions}><button type="button" onClick={() => setShowTelegramModal(false)} style={telegramCancelBtn}>Cancel</button><button type="button" onClick={handleSendTelegramApproval} disabled={isSendingTelegram} style={telegramSendBtn}>{isSendingTelegram ? "Sending…" : "Send Notification"}</button></div>
        </div>
      </div>
    )}
    </>
  );
}

/* ----------------------------------------------------------------------- */
/* Design tokens & shared styles                                           */
/* ----------------------------------------------------------------------- */

const fontStack = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

const pageWrap = {
  padding: "32px",
  background: "#f1f5f9",
  minHeight: "100vh",
  fontFamily: fontStack
};

const card = {
  background: "#ffffff",
  borderRadius: "16px",
  padding: "32px",
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05)"
};

const eyebrow = {
  fontSize: "11px",
  fontWeight: "700",
  letterSpacing: "0.08em",
  color: "#6366f1",
  marginBottom: "6px"
};

const pageTitle = {
  margin: 0,
  color: "#0f172a",
  fontSize: "30px",
  fontWeight: "700",
  letterSpacing: "-0.02em"
};

const pageSubtitle = {
  margin: "6px 0 0",
  color: "#64748b",
  fontSize: "14px"
};

const statusPill = {
  display: "inline-flex",
  alignItems: "center",
  gap: "7px",
  padding: "8px 16px",
  borderRadius: "20px",
  fontSize: "13px",
  fontWeight: "700",
  border: "1px solid",
  whiteSpace: "nowrap"
};

const statusDot = {
  width: "7px",
  height: "7px",
  borderRadius: "50%",
  display: "inline-block"
};

const metaBar = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  padding: "16px 22px",
  marginTop: "22px",
  marginBottom: "26px",
  gap: "20px"
};

const metaItem = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  minWidth: "90px"
};

const metaLabel = {
  fontSize: "11px",
  fontWeight: "600",
  color: "#94a3b8",
  textTransform: "uppercase",
  letterSpacing: "0.04em"
};

const metaValue = {
  fontSize: "14.5px",
  fontWeight: "700",
  color: "#0f172a"
};

const metaDivider = {
  width: "1px",
  height: "30px",
  background: "#e2e8f0"
};

const adminNotice = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "18px",
  marginBottom: "18px",
  padding: "14px 18px",
  border: "1px solid #c7d2fe",
  borderRadius: "12px",
  background: "linear-gradient(90deg, #eef2ff 0%, #fafaff 100%)"
};

const adminNoticeTitle = {
  color: "#312e81",
  fontSize: "13px",
  fontWeight: "800",
  marginBottom: "3px"
};

const adminNoticeText = {
  color: "#5b6478",
  fontSize: "12.5px"
};

const tableControls = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "14px",
  marginBottom: "12px",
  padding: "10px 2px"
};

const tableControlsLabel = {
  color: "#475569",
  fontSize: "12px",
  fontWeight: "800",
  textTransform: "uppercase",
  letterSpacing: "0.04em"
};

const toggleLabel = {
  display: "inline-flex",
  alignItems: "center",
  gap: "7px",
  color: "#475569",
  fontSize: "12.5px",
  fontWeight: "600",
  cursor: "pointer"
};

const tableWrap = {
  overflowX: "auto",
  borderRadius: "14px",
  border: "1px solid #e2e8f0"
};

const emptyState = {
  padding: "48px 20px",
  textAlign: "center",
  color: "#94a3b8",
  fontSize: "14px"
};

const theadRowPrimary = {
  background: "#f8fafc",
  color: "#0f172a"
};

const theadRowSecondary = {
  background: "#eef2f7",
  color: "#475569"
};

const thStyle = {
   padding: "10px 8px",
   fontSize: "11px",
   fontWeight: "700",
   textTransform: "uppercase",
   letterSpacing: "0.03em",
  border: "1px solid #dbe4ee",
   whiteSpace: "nowrap"
};

const tdStyle = {
   padding: "10px 8px",
   border: "1px solid #e5e7eb",
   fontSize: "13px",
   color: "#334155"
};

const bodyRow = {
  transition: "background 0.12s ease"
};

const thStyleLeft = { ...thStyle, textAlign: "left",
  minWidth: "220px"
};

const tdStyleLeft = {
  ...tdStyle,
  textAlign: "left",
  minWidth: "260px",
  maxWidth: "350px",
  lineHeight: "1.5",
  whiteSpace: "normal",
  wordBreak: "break-word",
  padding: "14px"
};

const tdStyleRight = { ...tdStyle, textAlign: "right",
  width: "100px",
  minWidth: "100px",
  maxWidth: "100px"
};

const adminInputStyle = {
  width: "88px",
  padding: "5px 7px",
  border: "1px solid #a5b4fc",
  borderRadius: "6px",
  background: "#ffffff",
  color: "#312e81",
  fontWeight: "600",
  fontSize: "13px",
  textAlign: "right",
  outline: "none"
};

const gstInputStyle = {
  width: "58px",
  padding: "5px 6px",
  border: "1px solid #a5b4fc",
  borderRadius: "6px",
  background: "#ffffff",
  color: "#312e81",
  fontWeight: "600",
  fontSize: "13px",
  textAlign: "center",
  outline: "none"
};

const thumbStyle = {
  width: 52,
  height: 52,
  objectFit: "cover",
  borderRadius: "8px",
  cursor: "pointer",
  border: "1px solid #e2e8f0"
};

const fileLinkStyle = {
  color: "#4338ca",
  fontSize: "12.5px",
  fontWeight: "600",
  textDecoration: "none"
};

const footerBar = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "28px",
  paddingTop: "22px",
  borderTop: "1px solid #e2e8f0"
};

const baseBtn = {
  border: "none",
  padding: "12px 22px",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "600",
  fontSize: "13.5px",
  letterSpacing: "0.01em",
  transition: "opacity 0.15s ease, transform 0.05s ease"
};

const approveBtn = { ...baseBtn, background: "#15803d", color: "#fff" };
const poBtn = { ...baseBtn, background: "#4338ca", color: "#fff" };
const notificationBtn = { ...baseBtn, background: "#0f766e", color: "#fff" };
const telegramOverlay = { position: "fixed", inset: 0, zIndex: 1200, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px", background: "rgba(15, 23, 42, 0.45)" };
const telegramModal = { width: "100%", maxWidth: "520px", maxHeight: "calc(100vh - 32px)", overflowY: "auto", background: "#fff", borderRadius: "14px", boxShadow: "0 20px 50px rgba(15,23,42,.25)" };
const telegramHeader = { display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "20px", borderBottom: "1px solid #e2e8f0" };
const telegramTitle = { color: "#0f172a", fontWeight: "700", fontSize: "17px" };
const telegramSubtitle = { marginTop: "3px", color: "#64748b", fontSize: "12px" };
const telegramCloseBtn = { border: 0, background: "transparent", color: "#64748b", fontSize: "24px", cursor: "pointer", lineHeight: 1 };
const telegramDetails = { margin: "18px 20px", padding: "12px 14px", borderRadius: "9px", background: "#f0fdfa", color: "#134e4a", fontSize: "13px", lineHeight: 1.8 };
const telegramRecipientNote = { margin: "0 20px 16px", padding: "10px 12px", borderRadius: "8px", background: "#f8fafc", color: "#64748b", fontSize: "11px" };
const telegramLabel = { display: "block", margin: "0 20px 14px", color: "#475569", fontSize: "12px", fontWeight: "600" };
const telegramInput = { display: "block", width: "100%", marginTop: "6px", padding: "10px 11px", border: "1px solid #cbd5e1", borderRadius: "8px", fontSize: "13px", boxSizing: "border-box" };
const telegramTextarea = { ...telegramInput, resize: "vertical", fontFamily: "inherit", lineHeight: 1.5 };
const telegramPreview = { margin: "0 20px 18px", padding: "12px 14px", border: "1px solid #e2e8f0", borderRadius: "9px", color: "#475569", fontSize: "12px" };
const telegramPre = { margin: "8px 0 0", whiteSpace: "pre-wrap", fontFamily: "inherit", color: "#0f172a", lineHeight: 1.5 };
const telegramActions = { display: "flex", justifyContent: "flex-end", gap: "10px", padding: "16px 20px", borderTop: "1px solid #e2e8f0" };
const telegramCancelBtn = { ...baseBtn, background: "#fff", color: "#475569", border: "1px solid #cbd5e1" };
const telegramSendBtn = { ...baseBtn, background: "#0f766e", color: "#fff" };
const editRatesBtn = { ...baseBtn, background: "#4338ca", color: "#fff", padding: "9px 15px", whiteSpace: "nowrap" };
const saveAdminBtn = { ...baseBtn, background: "#4338ca", color: "#fff" };
const cancelBtn = { ...baseBtn, background: "#ffffff", color: "#475569", border: "1px solid #cbd5e1" };

const modalOverlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
};

const modalBox = {
    background: "#fff",
    width: 450,
    borderRadius: 12,
    padding: 25
};

const modalInput = {
    width: "100%",
    padding: 10,
    marginTop: 12,
    border: "1px solid #ddd",
    borderRadius: 6
};

export default ComparisonDetailsPage;
